export default __webpack_public_path__ + "static/principle-integrated-dark-02a5300437c3d5ab37128921594f43fe.png";